import { render } from "./EditBanner.vue?vue&type=template&id=ed80bc24"
import script from "./EditBanner.vue?vue&type=script&lang=js"
export * from "./EditBanner.vue?vue&type=script&lang=js"

import "./EditBanner.vue?vue&type=style&index=0&id=ed80bc24&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__